import { config } from "@repo/config";
import { AuditLog } from "@saas/organizations/components/AuditLog";
import { AdminOnlyNotice } from "@saas/settings/components/SettingsLayout";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const auditLogSearchSchema = z.object({
	page: z.number().int().min(1).default(1),
	action: z.string().default(""),
});

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/settings/audit",
)({
	validateSearch: auditLogSearchSchema,
	head: () => ({ meta: [{ title: `Audit log - ${config.appName}` }] }),
	component: OrganizationAuditPage,
});

function OrganizationAuditPage() {
	const { organization, isOrganizationAdmin } = Route.useRouteContext();

	if (!isOrganizationAdmin) {
		return <AdminOnlyNotice what="the audit log" />;
	}

	return <AuditLog organizationId={organization.id} />;
}
